var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('case-back-div',{attrs:{"to":_vm.backTo}}),_c('wizard-container',{staticClass:"mt-3",attrs:{"show-all":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }